import { useState, useEffect } from 'react'

/**
 * A custom React hook that returns the value of a specific URL search parameter
 * @param {string} name - The name of the search parameter to retrieve
 *
 * @returns {string|null} The value of the search parameter or null if not found
 */
export const useSearchParam = (name) => {
  const [paramValue, setParamValue] = useState(() => {
    const searchParams = new URLSearchParams(window.location.search)
    return searchParams.get(name)
  })

  useEffect(() => {
    const handleUrlChange = () => {
      const searchParams = new URLSearchParams(window.location.search)
      setParamValue(searchParams.get(name))
    }

    window.addEventListener('popstate', handleUrlChange)
    return () => window.removeEventListener('popstate', handleUrlChange)
  }, [name])

  return paramValue
}
